import { ActionExtended } from "src/_common/interfaces/ActionExtended";
import { ACTIONS } from "src/_config";

export interface EventReducer {
  gameDetails: any;
  groups: any;
  rodeoEvents: any;
  rodeoEventDetails: any;
  pastRodeoEvents: any;
  performances: any;
  performanceDetails: any;
  events: any;
  eventDetails: any;
  riders: any;
  activePerformances: any;
  categorizedPerformances: any;
  categorizedRodeoEvents: any;
  categorizedEventGroups: any;
  eventGroupsLeaderboard: any;
  rodeoLeaderboard: any;
  performanceLeaderboard: any;
  sidebarPerformanceLeaderboard: any;
  sidebarRodeoLeaderboard: any;
  sidebarEventGroupsLeaderboard: any;
  makePickModalApiResponse: any;
  viewPicksModalApiResponse: any;
  statusMsg: any;
  myPickList: any;
  tvImage: any;
}

const initialState: EventReducer = {
  gameDetails: null,
  groups: null,
  rodeoEvents: null,
  rodeoEventDetails: null,
  pastRodeoEvents: null,
  performances: null,
  performanceDetails: null,
  events: null,
  eventDetails: null,
  riders: null,
  activePerformances: null,
  categorizedPerformances: null,
  categorizedRodeoEvents: null,
  categorizedEventGroups: null,
  eventGroupsLeaderboard: null,
  rodeoLeaderboard: null,
  performanceLeaderboard: null,
  sidebarPerformanceLeaderboard: null,
  sidebarRodeoLeaderboard: null,
  sidebarEventGroupsLeaderboard: null,
  makePickModalApiResponse: null,
  viewPicksModalApiResponse: null,
  statusMsg: null,
  myPickList: null,
  tvImage: null,
};

const eventReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.EVENT.RODEO_EVENT_EVENTS:
      return {
        ...state,
        makePickModalApiResponse: action.payload,
      };
    case ACTIONS.EVENT.RODEO_EVENT_YOUR_PICKS:
      return {
        ...state,
        viewPicksModalApiResponse: action.payload,
      };
    case ACTIONS.EVENT.GAME_DETAILS:
      return {
        ...state,
        gameDetails: action.payload,
      };
    case ACTIONS.EVENT.GROUPS:
      return {
        ...state,
        groups: action.payload,
      };
    case ACTIONS.EVENT.RODEO_EVENTS:
      return {
        ...state,
        rodeoEvents: action.payload,
      };
    case ACTIONS.EVENT.PAST_RODEO_EVENTS:
      return {
        ...state,
        pastRodeoEvents: action.payload,
      };
    case ACTIONS.EVENT.RODEO_EVENT_DETAILS:
      return {
        ...state,
        rodeoEventDetails: action.payload,
      };
    case ACTIONS.EVENT.PERFORMANCES:
      return {
        ...state,
        performances: action.payload,
      };
    case ACTIONS.EVENT.PERFORMANCE_DETAILS:
      return {
        ...state,
        performanceDetails: action.payload,
      };
    case ACTIONS.EVENT.EVENTS:
      return {
        ...state,
        events: action.payload,
      };
    case ACTIONS.EVENT.EVENT_DETAILS:
      return {
        ...state,
        eventDetails: action.payload,
      };
    case ACTIONS.EVENT.GAME_STATUS_TEXT:
      return {
        ...state,
        gameDetails: {
          ...state.gameDetails,
          status_text: {
            ...state.gameDetails?.status_text,
            text: action.payload,
          },
        },
      };
    case ACTIONS.EVENT.RODEO_EVENT_STATUS_TEXT: {
      const updatedRodeoEventDetails = {
        ...state.rodeoEventDetails,
        active_status_message: {
          ...state.rodeoEventDetails?.active_status_message,
          text: action.payload,
        },
      };

      const updatedRodeoEventsList = state.rodeoEvents?.list?.map((r: any) => {
        if (r.id == updatedRodeoEventDetails.id) {
          return {
            ...r,
            active_status_message: {
              ...r?.active_status_message,
              text: action.payload,
            },
          };
        }
        return r;
      });

      return {
        ...state,
        rodeoEventDetails: updatedRodeoEventDetails,
        rodeoEvents: {
          ...state.rodeoEvents,
          list: updatedRodeoEventsList,
        },
      };
    }

    case ACTIONS.EVENT.RODEO_EVENT_GLOW:
      return {
        ...state,
        rodeoEvents: {
          ...state.rodeoEvents,
          list: state.rodeoEvents?.list?.map((r: any) => {
            if (r.id == action.payload.rodeo_event_id) {
              return {
                ...r,
                game_info: {
                  ...r.game_info,
                  glow_event_game: action.payload.glow_event_game,
                },
              };
            }
            return r;
          }),
        },
      };

    case ACTIONS.EVENT.GROUP_EVENT_GLOW:
      return {
        ...state,
        groups: {
          ...state.groups,
          list: state.groups?.list?.map((g: any) => {
            const matchingPayload = action.payload.find((p: any) => p.group_id == g.id);
            if (matchingPayload) {
              return {
                ...g,
                is_glowing: matchingPayload.is_glowing,
              };
            }
            return g;
          }),
        },
      };

    case ACTIONS.EVENT.EVENT_STATUS_UPDATE: {
      const updatedEventsList = state.events?.list?.map((r: any) => {
        if (r.id == action.payload.id) {
          return {
            ...r,
            status: action.payload.status,
          };
        }
        return r;
      });
      const updatedEventDetails = state.eventDetails
        ? updatedEventsList?.find((r: any) => r.id == state.eventDetails.id)
        : { ...state.eventDetails };

      const modalData = state.makePickModalApiResponse;
      const updatedModalData = modalData?.event_dtls
        ? {
            ...modalData,
            event_dtls: modalData.event_dtls.map((event: any) => {
              if (event.id == action.payload.id) {
                return { ...event, status: Number(action.payload.status) };
              }
              return event;
            }),
          }
        : modalData;

      return {
        ...state,
        eventDetails: updatedEventDetails,
        events: {
          ...state.events,
          list: updatedEventsList,
        },
        makePickModalApiResponse: updatedModalData,
      };
    }

    case ACTIONS.EVENT.PERFORMANCE_END_ALL_EVENTS:
      return {
        ...state,
        events: {
          ...state.events,
          list: state.events?.list?.map((r: any) => {
            if (r.performance_id == action.payload.performance_id) {
              return {
                ...r,
                status: 2,
              };
            }
            return r;
          }),
        },
        eventDetails: state.eventDetails ? { ...state.eventDetails, status: 2 } : null,
      };
    case ACTIONS.EVENT.PERFORMANCE_START_PICK:
      return {
        ...state,
        performances: {
          ...state.performances,
          list: state.performances?.list?.map((performance: any) => {
            if (performance.id == action.payload.performance.id) {
              return {
                ...performance,
                start_pick: action.payload.performance.start_pick,
              };
            }
            return performance;
          }),
        },
        performanceDetails: state.performanceDetails
          ? {
              ...state.performanceDetails,
              start_pick:
                state.performanceDetails.id == action.payload.performance.id
                  ? action.payload.performance.start_pick
                  : state.performanceDetails.start_pick,
            }
          : null,
      };
    case ACTIONS.EVENT.WINNER_DECLARED: {
      const updatedEvents = state.events?.list?.map((event: any) => {
        if (event.riders) {
          return {
            ...event,
            riders: event.riders.map((rider: any) => {
              if (rider.id === action.payload.rider_id) {
                return {
                  ...rider,
                  is_winner: action.payload.status,
                };
              }
              return rider;
            }),
          };
        }
        return event;
      });

      // Update makePickModalApiResponse if modal is open and matches
      const winnerModalData = state.makePickModalApiResponse;
      const updatedWinnerModalData =
        winnerModalData &&
        winnerModalData.rodeo_event_dtls?.id == action.payload.rodeo_event_id &&
        winnerModalData.performance_dtls?.id == action.payload.performance_id
          ? {
              ...winnerModalData,
              event_dtls: winnerModalData.event_dtls?.map((event: any) => {
                if (event.id == action.payload.rodeo_event_event_id) {
                  return {
                    ...event,
                    winning_declare: 1,
                    riders: event.riders?.map((rider: any) => {
                      if (rider.id == action.payload.contestant_id) {
                        return { ...rider, is_winner: 1 };
                      }
                      return rider;
                    }),
                  };
                }
                return event;
              }),
            }
          : winnerModalData;

      return {
        ...state,
        events: {
          ...state.events,
          list: updatedEvents,
        },
        eventDetails: state.eventDetails
          ? {
              ...state.eventDetails,
              riders: state.eventDetails.riders?.map((rider: any) => {
                if (rider.id == action.payload.rider_id) {
                  return {
                    ...rider,
                    is_winner: action.payload.status,
                  };
                }
                return rider;
              }),
            }
          : null,
        makePickModalApiResponse: updatedWinnerModalData,
      };
    }
    case ACTIONS.EVENT.APPLY_LEAGUE_CODE:
      return {
        ...state,
        performances: {
          ...state.performances,
          list: state.performances?.list?.map((performance: any) => {
            if (performance?.id == action.payload?.user_league_code?.performance_id) {
              return {
                ...performance,
                user_league_code: action.payload.user_league_code,
              };
            }
            return performance;
          }),
        },
        performanceDetails: state.performanceDetails
          ? {
              ...state.performanceDetails,
              user_league_code:
                state?.performanceDetails?.id == action.payload?.user_league_code?.performance_id
                  ? action.payload.user_league_code
                  : state.performanceDetails.user_league_code,
            }
          : null,
      };
    case ACTIONS.EVENT.ACTIVE_PERFORMANCES:
      return {
        ...state,
        activePerformances: action.payload,
      };
    case ACTIONS.EVENT.CATEGORIZED_PERFORMANCES:
      return {
        ...state,
        categorizedPerformances: action.payload,
      };
    case ACTIONS.EVENT.CATEGORIZED_RODEO_EVENTS:
      return {
        ...state,
        categorizedRodeoEvents: action.payload,
      };
    case ACTIONS.EVENT.CATEGORIZED_EVENT_GROUPS:
      return {
        ...state,
        categorizedEventGroups: action.payload,
      };
    case ACTIONS.EVENT.EVENT_GROUPS_LEADERBOARD:
      return {
        ...state,
        eventGroupsLeaderboard: action.payload,
      };
    case ACTIONS.EVENT.RODEO_LEADERBOARD:
      return {
        ...state,
        rodeoLeaderboard: action.payload,
      };
    case ACTIONS.EVENT.PERFORMANCE_LEADERBOARD:
      return {
        ...state,
        performanceLeaderboard: action.payload,
      };
    case ACTIONS.EVENT.SIDEBAR_PERFORMANCE_LEADERBOARD:
      return {
        ...state,
        sidebarPerformanceLeaderboard: action.payload,
      };
    case ACTIONS.EVENT.SIDEBAR_RODEO_LEADERBOARD:
      return {
        ...state,
        sidebarRodeoLeaderboard: action.payload,
      };
    case ACTIONS.EVENT.SIDEBAR_EVENT_GROUPS_LEADERBOARD:
      return {
        ...state,
        sidebarEventGroupsLeaderboard: action.payload,
      };
    case ACTIONS.EVENT.MY_PICK_LIST:
      return {
        ...state,
        myPickList: action.payload,
      };
    case ACTIONS.EVENT.TV_IMAGE:
      return {
        ...state,
        tvImage: action.payload,
      };
    case ACTIONS.EVENT.STATUS_MSG:
      return {
        ...state,
        statusMsg: action.payload,
      };
    case ACTIONS.EVENT.START_STOP_RP_EVENT: {
      const modalData = state.makePickModalApiResponse;
      if (
        !modalData ||
        modalData.rodeo_event_dtls?.id != action.payload.rodeo_event_id ||
        modalData.performance_dtls?.id != action.payload.performance_id
      ) {
        return state;
      }
      return {
        ...state,
        makePickModalApiResponse: {
          ...modalData,
          event_dtls: modalData.event_dtls?.map((event: any) => {
            if (event.id == action.payload.id) {
              return { ...event, status: Number(action.payload.status) };
            }
            return event;
          }),
        },
      };
    }
    default:
      return state;
  }
};

export default eventReducer;
